import { ActionEvent, Module } from "@/enums/enums";
import { GetLanguageType, GetTimezoneOffset, MerchantId, SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";
class ExportService {
  DoExportSSOSalary(salaryId: number) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      data: salaryId,
    };
    return service.peakPayrollAPI.post("/api/Export/ExportSSOSalary", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoExportSKLReport(salaryId: number) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      data: {
        salaryId: salaryId,
      },
    };
    return service.peakPayrollAPI.post("/api/Export/ExportSKLReport", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoExportPayRunSalary(salaryId: number) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      languageType: GetLanguageType(),
      data: salaryId,
    };
    return service.peakPayrollAPI.post("/api/Export/ExportPayRunSalary", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoExportPayRunSalaryPeriod(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      languageType: GetLanguageType(),
      data: {
        fromDate: input.fromDate.ToDateJsonString(),
        toDate: input.toDate.ToDateJsonString(),
      },
    };
    return service.peakPayrollAPI
      .post("/api/Export/ExportPayRunSalaryPeriod", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoCreateLogExportBankFile(salaryId: number) {
    const inputLog = {
      languageType: GetLanguageType(),
      merchantId: MerchantId(),
      data: {
        moduleId: Module.Salary,
        referenceId: salaryId,
        actionEventId: ActionEvent.ExportBankFile,
      },
    };
    service.peakPayrollAPI.post("/api/Log/CreateLog", inputLog, SetHeaderService());
  }
  DoExportImportTemplatePayRunSalary() {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      languageType: GetLanguageType(),
    };
    return service.peakPayrollAPI
      .post("/api/Export/ExportImportTemplatePayRunSalary", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoExportEmployeeByDepartment(departmentId: number) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      languageType: GetLanguageType(),
      data: departmentId,
    };
    return service.peakPayrollAPI
      .post("/api/Export/ExportEmployeeByDepartment", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoExportPayRunSalaryPnd1(salaryId: number) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      languageType: GetLanguageType(),
      data: {
        salaryId: salaryId,
      },
    };
    return service.peakPayrollAPI.post("/api/Export/ExportPayRunSalaryPnd1", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetPnd1KorTextFile(summarySalaryId: number) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      languageType: GetLanguageType(),
      data: summarySalaryId,
    };
    return service.peakPayrollAPI.post("/api/Export/GetPnd1KorTextFile", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}
export default new ExportService();
